import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import Form from "../../components/form";

export default function Menu(props) {
  const [menuId] = useState(Number(props.match.params.id));
  const [tipo, setTipo] = useState("");
  const { notification } = useContext(AppContext);
  const [comboMenus, setComboMenus] = useState([]);
  const [dadosMenu, setDadosMenu] = useState({});
  const history = props.history;
  const [editar, setEditar] = useState(false);

  useEffect(() => {
    carregarCombo();
    if (menuId > 0) carregarMenu();
  }, []);

  const carregarMenu = () => {
    api
      .get("menus/carregar", { id: menuId })
      .then((res) => {
        setDadosMenu(res);
        if (res.menuPaiId) {
          setTipo(2);
        } else {
          setTipo(1);
        }
        setEditar(true);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar menus");
      });
  };

  const carregarCombo = () => {
    api
      .get("menus/listar", { apenasPais: true })
      .then((res) => {
        setComboMenus(res);
      })
      .catch((err) => {
        notification("error", "Não foi possível carregar menus");
      });
  };

  const carregarForm = (param) => {
    setTipo(param.tipo);
  };

  const fTipo = {
    title: "Tipo",
    form: {
      tipo: {
        label: "Tipo",
        type: "select",
        emptyItem: true,
        // space: 4,
        options: [
          {
            value: 1,
            desc: "Pai",
          },
          {
            value: 2,
            desc: "Filho",
          },
        ],
        value: tipo,
      },
    },

    submit: {
      // label: "Buscar",
      action: carregarForm,
      auto: true,
    },
  };

  const salvar = (params) => {
    let dadosParams = params;

    if (menuId > 0) dadosParams.id = menuId;
    setDadosMenu(dadosParams);
    if (menuId > 0) {
      api
        .post("menus/editar", dadosParams)
        .then((res) => {
          notification("success", "Menu Editado!");
          setDadosMenu({});
          history.push(`/app/menu`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            case 2:
              return notification("error", "Menu pai inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    } else {
      api
        .put("menus/inserir", dadosParams)
        .then((res) => {
          notification("success", "Menu inserido!");
          setDadosMenu({});
          history.push(`/app/menu`);
        })
        .catch((err) => {
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Nome inválido");
            case 2:
              return notification("error", "Menu pai inválido");
            default:
              return notification("error", "Dados inválidos");
          }
        });
    }
  };

  const fPai = {
    title: "Dados Pai",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        value: dadosMenu.nome,
      },
      icone: {
        label: "Ícone",
        type: "text",
        space: 3,
        value: dadosMenu.icone,
      },
      ordem: {
        label: "Ordem",
        type: "number",
        space: 3,
        value: dadosMenu.ordem,
      },
      sistema: {
        label: "Sistema",
        type: "select",
        emptyItem: true,
        space: 6,
        options: [
          {
            value: 0,
            desc: "(Todos)",
          },
          {
            value: 1,
            desc: "Painel Administrativo",
          },
          {
            value: 2,
            desc: "Painel Escolas",
          },
        ],
        value: dadosMenu.sistema,
      },

      grupo: {
        label: "Grupo",
        type: "select",
        emptyItem: true,
        space: 6,
        options: [
          {
            value: 1,
            desc: "Perto Bilíngue",
          },
          {
            value: 2,
            desc: "Painel Escolas",
          },
          {
            value: 3,
            desc: "Pedidos",
          },
          {
            value: 4,
            desc: "Controle Financeiro Escolar",
          },
        ],
        value: dadosMenu.grupo,
      },
      ativo: {
        label: "Ativo",
        type: "check",
        value: dadosMenu.ativo,
      },
    },

    submit: {
      label: "Salvar",
      action: salvar,
    },
    history,
    close: true,
  };

  const fFilho = {
    title: "Dados Filho",
    form: {
      menuPaiId: {
        label: "Menu pai",
        type: "select",
        emptyItem: true,
        space: 6,
        array: {
          data: comboMenus,
          value: "id",
          desc: "nome",
        },
        value: dadosMenu.menuPaiId,
      },
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        value: dadosMenu.nome,
      },
      ordem: {
        label: "Ordem",
        type: "number",
        space: 6,
        value: dadosMenu.ordem,
      },
      rota: {
        label: "Rota",
        type: "text",
        space: 6,
        value: dadosMenu.rota,
      },
      ativo: {
        label: "Ativo",
        type: "check",
        // space: 6,
        value: dadosMenu.ativo,
      },
    },

    submit: {
      label: "Salvar",
      action: salvar,
    },

    history,
    close: true,
  };

  return (
    <div>
      {!editar && <Form formData={fTipo} />}
      {tipo === 1 && <Form formData={fPai} />}
      {tipo === 2 && <Form formData={fFilho} />}
    </div>
  );
}
